export default __webpack_public_path__ + "static/media/banner1.7288d5e8.jpg";